export default __webpack_public_path__ + "static/media/sun.45c5d578.mp3";